"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes time value as it is stored the ssg forms state and
 * converts it to a time string in the format HH:mm:ss
 * @param timeValue
 * @param isMilitaryTime
 */
exports.getTimeString = function (timeValue, isMilitaryTime) {
    var modifiedHours = timeValue.hour;
    if (!isMilitaryTime) {
        var hoursNum = parseInt(timeValue.hour, 10);
        if (timeValue.period === 'AM' && hoursNum === 12) {
            modifiedHours = '00';
        }
        else if (timeValue.period === 'PM' && hoursNum !== 12) {
            modifiedHours = (hoursNum + 12).toString();
        }
    }
    return modifiedHours + ":" + timeValue.minute + ":00";
};
//# sourceMappingURL=time-utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/time-utilities.js
// module id = 1160
// module chunks = 0